export default __webpack_public_path__ + "static/three-phones-2ed69ad2e791836537141aebe0a2575e.png";